export default __webpack_public_path__ + "static/media/slide3.fec54f23.png";